import type { FaireProductEntity } from "../../entity_types/product";

export const p_jdexwg22hm: FaireProductEntity = {
  token: "p_jdexwg22hm",
  type: "product",
  name: "Arroyo Oak – Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/5d759d42313f63ced990b150d4af8b7b082db474169a6cacc743923f5e777741.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f131e99b12fd8cc92dcfeb0b540ef29de42f212fd5c3e9458b04b7414b92cd57.jpeg",
    "https://cdn.faire.com/fastly/7d6bf3a0ea6389a47ee9477dca397359384cbed839ad6f8be34d45e54e85eb8b.png",
    "https://cdn.faire.com/fastly/4afab458078f2498b5062052fc198c2520be8310e89e643631ce5314af81d552.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/680db2dc6f2e02f245227d7707f0cc42096262ec843ba84cd9a1fd7454d46180.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'A love letter to the quiet wild of the Arroyo Seco. A passageway of twisted terrain perfumed by native sagebrush, crushed oak leaves, shady creek beds, and canyon stone. Vetiver, frankincense, & California oak.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:59.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
